module.exports = __webpack_public_path__ + "static/media/faqIcon.2942aeee.svg";